import React from "react"

const OrganisationsContext = React.createContext({})

const { Provider, Consumer } = OrganisationsContext

export { Provider, Consumer, OrganisationsContext }
